import React from 'react';
import { Steps } from 'antd';
import {
  DataValidation,
  Edtf,
  FileSelect,
  Visit,
} from '@dynamika-shared/ui/icons';
import { twMerge } from 'tailwind-merge';
import { UploadDrawerStep } from '@components/SiteUserUpload/types/uploadTypes';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';
import { isUnscheduledVisitName } from '@components/SiteUserUpload/helpers/visitHelpers';
import { useSiteUploadSlice } from '@restore/siteUpload/siteUpload.slice';

type UploadDrawerStepsProps = {
  currentStep: number;
  hasFile: boolean;
  visitName?: string | null;
};

export const UploadDrawerSteps: React.FC<UploadDrawerStepsProps> = ({
  currentStep,
  hasFile,
  visitName,
}) => {
  const data = useSiteUploadSlice(state => state.data);
  const name = isUnscheduledVisitName(visitName)
    ? 'Unscheduled'
    : visitName ?? data?.visitName;

  const stepsData = [
    {
      key: 'selectVisit',
      title: (
          <TruncatedText
            text={name ?? 'Select Visit'}
            truncate
            tooltip
            className='max-w-64 block'
          />
      ),
      icon: <Visit />,
    },
    {
      key: 'edtf',
      title:
        currentStep > UploadDrawerStep.EdtfStep
          ? 'eDTF Filled '
          : 'Fill in eDTF',
      icon: <Edtf />,
    },
    {
      key: 'fileSelect',
      title: hasFile ? 'File Selected' : 'Select File',
      icon: <FileSelect />,
    },
    {
      key: 'dataValidation',
      title: 'Data Validation',
      icon: <DataValidation />,
    },
  ];

  return (
    <Steps
      current={currentStep}
      size='small'
      labelPlacement='vertical'
      className='pb-2 w-5/6'
      data-testid='UploadDrawerSteps'
      items={stepsData.map((step, index) => {
        const isCurrentStep = index === currentStep;
        const isPrevSteps = index < currentStep;
        return {
          ...step,
          title: (
            <p
              className={twMerge(
                '-mr-3 text-pastelBlue',
                isCurrentStep && 'text-black'
              )}
            >
              {step.title}
            </p>
          ),

          icon: (
            <div
              className={twMerge(
                'h-6 w-6 rounded-full p-1.5',
                'bg-pageBackgroundWhite text-pastelBlue',
                isCurrentStep && 'bg-vividTangelo text-white',
                isPrevSteps && 'bg-seashell text-vividTangelo'
              )}
            >
              {step.icon}
            </div>
          ),
        };
      })}
    />
  );
};
